import { useEffect, useState } from "react";
import { IMAGE_DATA } from "./imageData";

const ImageGalleryLayout = () => {
  const [activeImage, setActiveImage] = useState<string | null>(null);

  // Disable right click only when modal is open
  useEffect(() => {
    if (!activeImage) return;

    document.body.style.overflow = "hidden";
    const disableRightClick = (e: MouseEvent) => e.preventDefault();
    document.addEventListener("contextmenu", disableRightClick);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, [activeImage]);

  return (
    <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
      {/* Header */}
      <div className="text-center mb-10 sm:mb-14">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-primary">
          Image Gallery
        </h2>
        <p className="mt-2 sm:mt-3 text-sm sm:text-base text-text-tertiary max-w-2xl mx-auto">
          A glimpse into our innovation, craftsmanship, and precision-driven work.
        </p>
      </div>

      {/* Gallery Grid */}
      <div
        className="
          grid gap-4 sm:gap-5 lg:gap-6
          grid-cols-1
          sm:grid-cols-2
          md:grid-cols-3
          lg:grid-cols-4
        "
      >
        {IMAGE_DATA.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveImage(item.image)}
            className="
              relative overflow-hidden rounded-xl
              shadow-sm hover:shadow-xl
              transition-all duration-500
              focus:outline-none
            "
          >
            <img
  src={item.image}
  loading="lazy"
  decoding="async"
  alt={`Gallery model ${item.id}`}
  draggable={false}
  className="w-full h-56 sm:h-64 md:h-60 lg:h-64 object-cover
             transition-transform duration-700 hover:scale-110
             select-none pointer-events-none"
/>


            {/* Overlay */}
            <div
              className="
                absolute inset-0
                bg-black/30
                opacity-0 hover:opacity-100
                transition-opacity duration-300
                flex items-center justify-center
              "
            >
              <span className="text-white text-xs sm:text-sm tracking-wide">
                Tap to View
              </span>
            </div>
          </button>
        ))}
      </div>

      {/* Modal */}
      {activeImage && (
        <div
          className="
            fixed inset-0 z-50
            bg-black/85
            flex items-center justify-center
            px-3 sm:px-6
          "
          onClick={() => setActiveImage(null)}
        >
          <div
            className="
              relative
              w-full
              max-w-[95vw] sm:max-w-4xl lg:max-w-5xl
            "
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={activeImage}
              alt="Gallery Preview"
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
              className="
                w-full
                max-h-[80vh] sm:max-h-[85vh]
                object-contain
                rounded-lg
                shadow-2xl
                select-none
                pointer-events-none
              "
            />

            {/* Close Button */}
            <button
              onClick={() => setActiveImage(null)}
              className="
                absolute top-3 right-3
                bg-black/60 text-white
                text-xs sm:text-sm
                px-3 py-1.5
                rounded-full
                backdrop-blur
                hover:bg-black/80
                transition
              "
            >
              ✕ Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default ImageGalleryLayout;
